<ul class="navbar-nav me-auto">
  <li></li>
  <li class="nav-item">
    <app-nav-search></app-nav-search>
  </li>
</ul>
